/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_TitleInputs */

const es_privacy_policy_scope_title = /** @type {(inputs: Privacy_Policy_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Alcance`)
};

const en_privacy_policy_scope_title = /** @type {(inputs: Privacy_Policy_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Scope`)
};

/**
* | output |
* | --- |
* | "2. Scope" |
*
* @param {Privacy_Policy_Scope_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_title = /** @type {((inputs?: Privacy_Policy_Scope_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_title(inputs)
	return en_privacy_policy_scope_title(inputs)
});
export { privacy_policy_scope_title as "privacy_policy.scope.title" }